export const setAppError = (error) => ({
	type: 'SET_APP_ERROR',
	payload: error,
})

export const setAppLoading = (loading) => ({
	type: 'SET_APP_LOADING',
	payload: loading
})
